import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { messageicon } from "../../../assets/icons";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { sendEmailOtpValidation } from "../../../validations";
import { AuthService } from "../../../services";
import useSnackbar from "../../../hooks/useSnackbar";
import { useMutation } from "@tanstack/react-query";
import ButtonLoader from "../../../component/buttonLoader";
import { decryptData } from "../../../utils/helper";

const Email = () => {
  const navigate = useNavigate();
  const { snackbar } = useSnackbar();
  const { sendOtp } = AuthService();

  const {
    register,
    getValues,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(sendEmailOtpValidation),
    defaultValues: {
      email: "",
    },
  });

  // console.log("hhhh",decryptData("U2FsdGVkX1/hFhoIoWV0wPF58cMOHrKoEtcCuWCT/9QL6yxndCGFqr8iLRNCzdwcoN9y58MPd9qLwSGVzSC7Feab7WEfoMoN99kqdkP2MZw="))
  // console.log("get",decryptData("U2FsdGVkX185xE8VyJ4WTtPZSeLdIjD0FZoV7UJ9jJnEbXhGZAFYVU6tYEdIlMYAU9SAIEUVgSNQFSYOzga/30JXyB7DPcs2kBnkxBlR89w="))

  const sendOtpMutation = useMutation({
    mutationFn: (data) => {
      return sendOtp({ ...data, type: "register" });
    },
    onSuccess: (data) => {
      navigate("/otp", {
        state: {
          ...getValues(),
          screen: "register",
        },
      });
      snackbar(data?.message || "", "info");
    },
    onError: (err) => {
      snackbar(err.data.message || "");
    },
  });

  return (
    <div className="signup_wrap">
      
      <form onSubmit={handleSubmit(sendOtpMutation.mutate)}>
        <div className="form_field icon_set">
          <label className="label" htmlFor="">
            Email Address
          </label>
          <input
            {...register("email")}
            type="email"
            className="input form-control"
            placeholder="Enter Your Email"
          />
          <img src={messageicon} alt="icon" />
          {errors.email && (
            <span className="error">{errors.email?.message}</span>
          )}
        </div>

        <div className="btn_wrap_login">
          <ButtonLoader
            className="login"
            isLoading={sendOtpMutation.isPending}
            text={
              <>
                Verify <FaArrowRightLong />
              </>
            }
          />
        </div>
      </form>
      <div className="account_signup">
        <p>
          By signing up, you agree to and{" "}
          <Link to="/terms"> Terms & Conditions </Link>
          <Link to="/policy">Privacy Policy.</Link>
        </p>
      </div>
    </div>
  );
};

export default Email;
